/* eslint-disable @typescript-eslint/no-explicit-any */

import _ from 'lodash';

import { AdminResourceDataProvider } from './AdminResourceDataProvider';
import { DataProviderOperation } from './BaseResourceDataProvider';

export abstract class ClientAdminResourceDataProvider extends AdminResourceDataProvider {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected getFields(resource: string, operation: DataProviderOperation): string {
    return `
          id 
          client {id user { id email subject }} 
          creationTimestamp 
          updateTimestamp`;
  }

  protected getParamTypes(resource: string, operation: DataProviderOperation): Record<string, string> {
    switch (operation) {
      case 'create':
        return {
          clientId: 'ID!',
          [this.getInputFieldName(resource, operation)]: `${resource}Input!`,
        };
      default:
        return super.getParamTypes(resource, operation);
    }
  }

  protected getDataFieldsToExclude(resource: string, operation: DataProviderOperation, params: any): string[] {
    return super.getDataFieldsToExclude(resource, operation, params).concat(['clientId', 'client', 'objectUserId']);
  }

  protected transformParams(resource: string, operation: DataProviderOperation, params: any): any {
    switch (operation) {
      case 'create':
        return {
          clientId: params.data.clientId,
          [this.getInputFieldName(resource, operation)]: _.omit(
            params.data,
            this.getDataFieldsToExclude(resource, operation, params),
          ),
        };
      default:
        return super.transformParams(resource, operation, params);
    }
  }
}
